var _rect, _rect2, _line, _g, _g2, _line2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalkInShower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "walk-in-shower",
    viewBox: "0 0 113.4 199",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 40.9,
    width: 109.4,
    height: 146.9,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 188.1,
    width: 109.6,
    height: 8.9,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.8789
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 97,
    x2: 97,
    y1: 42,
    y2: 187.8,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.9,
    y: 6.5,
    width: 25.7,
    height: 7.2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "52.2 6.2 52.2 1.4 61.3 1.4 61.3 6.2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.9,
    y: 17.2,
    width: 1.9,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9,
    y: 24,
    width: 1.9,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.9,
    y: 30.7,
    width: 1.9,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.1338 -.991 .991 .1338 26.904 69.549)",
    x: 51.1,
    y: 18.4,
    width: 4.2,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.1339 -.991 .991 .1339 19.495 74.437)",
    x: 50.2,
    y: 25.1,
    width: 4.2,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.134 -.991 .991 .134 12.09 79.325)",
    x: 49.3,
    y: 31.8,
    width: 4.2,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.9939 -.1107 .1107 .9939 -1.7718 6.8269)",
    x: 59.6,
    y: 17.3,
    width: 1.9,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.9939 -.1102 .1102 .9939 -2.4989 6.9165)",
    x: 60.4,
    y: 24,
    width: 1.9,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.9939 -.1102 .1102 .9939 -3.2328 7.0392)",
    x: 61.1,
    y: 30.7,
    width: 1.9,
    height: 4.2
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 87.5,
    x2: 87.5,
    y1: 115.3,
    y2: 132.6,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkInShower);
export default __webpack_public_path__ + "static/media/walk-in-shower.338003e8d46fa14a424ac82afeae4649.svg";
export { ForwardRef as ReactComponent };